import './filter-button-dropdown.component.scss';
import { useEffect, useState } from 'react';
import { FilterSelectedValue } from '../../../../hooks/filters/interfaces/filter-selected-value.interface';
import { FilterButtonDropdownBasicComponent } from './filter-button-dropdown-basic.component';
import { FilterButtonComponentProps } from './filter-button-dropdown.component';
export type FilterButtonDropdownStandAloneComponentProps =
  FilterButtonComponentProps;

/**
 * Stores filter selection in this component and comunicates to listeners.
 * @param
 * @returns
 */
export const FilterButtonDropdownStandAloneComponent = ({
  onSelect,
  filter,
  filterSelection,
  disabled,
  variant = '',
  searchBox = true,
  defaultLabel = 'All',
  disabledOptions,
}: FilterButtonDropdownStandAloneComponentProps) => {
  const [selectedValue, setSelectedValue] = useState<
    FilterSelectedValue | undefined
  >();

  useEffect(() => {
    if (filterSelection) {
      const selVal = filterSelection.find((i) => i.id === filter.id);
      //const hasSelVal = hasFilterSelectedValue(selVal)
      if (selVal) {
        setSelectedValue((prevVal) => prevVal ?? selVal);
      } else {
        setSelectedValue(
          (prevVal) =>
            prevVal ?? {
              id: filter.id,
              values: [],
              matchStrategy: filter.defaultSelectedValue?.matchStrategy,
            },
        );
      }
    }
  }, [filter.id, filter.defaultSelectedValue, filterSelection]);

  return (
    <FilterButtonDropdownBasicComponent
      selectedValue={selectedValue}
      setSelectedValue={setSelectedValue}
      onSelect={onSelect}
      filter={filter}
      filterSelection={filterSelection}
      disabled={disabled}
      variant={variant}
      searchBox={searchBox}
      defaultLabel={defaultLabel}
      disabledOptions={disabledOptions}
    />
  );
};
